import React from 'react'
import { Button } from '@the-platform-group/component-library/Button'
import { Sync as RefreshIcon } from '@the-platform-group/component-library/Icons'
import { CircularProgress } from '@the-platform-group/component-library'
import useRocketReachLookup from '../hooks/useRocketReachLookup'
import useContactLookupState from '../hooks/useContactLookupState'

/**
 * Rocket Reach Search Row Actions Component
 * @param {Object} row - The row data
 * @returns {React.Component} - The RocketReachActions component that displays get contact lookup button
 */
const RocketReachActions = ({ row }) => {
  const { handleGetContactDetails, isContactPolling } = useRocketReachLookup()
  const { hasLookupData, isFetching } = useContactLookupState(row.id)

  const isPolling = isContactPolling(row.id)

  const isContactLoading = isFetching || isPolling

  return (
    <Button
      variant="contained"
      size="small"
      onClick={() => handleGetContactDetails(row.id)}
      disabled={isContactLoading}
      color={hasLookupData ? 'secondary' : 'primary'}
      startIcon={hasLookupData && !isContactLoading ? <RefreshIcon /> : null}
      sx={{
        minWidth: 160,
        ...(hasLookupData && {
          '&:hover': {
            color: 'primary.contrastText',
          },
        }),
      }}
    >
      {isContactLoading && <CircularProgress size={20} />}
      {!isContactLoading && (hasLookupData ? 'Refresh details' : 'Get contact info')}
    </Button>
  )
}

export default RocketReachActions
